import axios from "axios";
import { getAccessTokenFromCookies, isExistsCookies } from "./cookies";
// import {
//   isExistsCookies,
//   getAccessTokenFromCookies,
//   getAccessTokenFromResponseHeader,
// } from "./cookies";

// import { memoizedRefreshToken } from "./refresh-token";

const instance = axios.create({
    baseURL: process.env.REACT_APP_BASEURL_API,
    withCredentials: true,
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
    },
});

instance.interceptors.request.use(
    (config) => {
        if (isExistsCookies()) {
            config.headers = {
                ...config.headers,
                tokek: `${getAccessTokenFromCookies()}`,
            };
        }
        return config;
    },
    (error) => {
        Promise.reject(error);
    }
);

instance.interceptors.response.use(
    (response) => {
        return response;
    },
    async (error) => {
        // const config = error?.config;
        // if (error?.response?.status === 401 && !config?.sent) {
        //   config.sent = true;

        //   const responseRefreshToken = await memoizedRefreshToken();
        //   const accessToken = getAccessTokenFromResponseHeader(responseRefreshToken);
        //   if (accessToken) {
        //     config.headers = {
        //       ...config.headers,
        //       tokek: `${accessToken}`,
        //     };
        //   }
        //   return axios(config);
        // }
        return Promise.reject(error);
    }
);
export default instance;
